import { Translate } from './LanguageService';

export function toNamedError(errorResponse: { errors: any[] }) {
    let errors: any = {};
    errorResponse.errors.forEach((e: any) => {
        let lowerCaseFirstLetterInKey = e.key.charAt(0).toLowerCase() + e.key.slice(1);
        errors[lowerCaseFirstLetterInKey] = Translate(e.value);
    });
    return errors;
}
